import React from "react";
import { useTheme } from "@material-ui/core/styles";
import { useMediaQuery } from "@material-ui/core";

import { reverse } from "ramda";

import { percentageFormat } from "lib/formats";

const formatPercentageTick = percentageFormat;


const MapColorsLegend = ({ colorScale }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"), {
    defaultMatches: true,
  });

  const niceScale = colorScale;//.copy().nice();
  const stops = reverse(niceScale.ticks(10));
  const stepOffset = 100 / stops.length;

  const tickTypography = isMobile
    ? theme.typography.body2[theme.breakpoints.down("sm")]
    : theme.typography.body2[theme.breakpoints.up("sm")];

  const domain = niceScale.domain();

  return (
    <svg width={50} height={isMobile ? 150 : 200}>
      <defs>
        <linearGradient id="linear-gradient" x1="0%" y1="0%" x2="0" y2="100%">
          {stops.map((val, idx) => {
            return (
              <stop
                offset={`${idx * stepOffset}%`}
                stopColor={niceScale(val)}
                key={val}
              />
            );
          })}
        </linearGradient>
      </defs>
      <rect width={10} height={200} fill="url('#linear-gradient')" />
      <g>
        <text
          style={{ ...tickTypography }}
          x="14"
          y="10"
          transform="translate(0,0)"
        >
          {formatPercentageTick(domain[2])}
        </text>
        ;
        <text
          style={{ ...tickTypography }}
          x="14"
          y="50%"
          transform="translate(0,0)"
        >
          {formatPercentageTick(domain[1])}
        </text>
        ;
        <text
          style={{ ...tickTypography }}
          x="14"
          y="98%"
          transform="translate(0,0)"
        >
          {formatPercentageTick(domain[0])}
        </text>
        ;
      </g>
    </svg>
  );
};

export default React.memo(MapColorsLegend);
